import { Grid } from '@material-ui/core';
import * as React from 'react';

interface IProps {
    name: string;
    description: string;
}

export const ProjectHeader: React.FC<IProps> = ({
    name,
    description,
}) => (
        <div className="projectHeader">
            <Grid container>
                <Grid item md={6}>
                    <h1 className="projectHeader__name">{name}</h1>
                </Grid>
                <Grid item md={6} className="projectHeader__description">
                    <p dangerouslySetInnerHTML={{ __html: description }} />
                </Grid>
            </Grid>
        </div>
    );
